import { useEffect } from "react";
import type { TranslationKey } from "@privacy/translations";
import { useTranslation } from "@privacy/translations";

export const usePrivacyDocumentTitle = (titleKey?: TranslationKey) => {
  const { t } = useTranslation();

  const title = titleKey ? t("DocumentTitle", { pageTitle: t(titleKey) }) : t("DocumentTitleDefault");
  useEffect(() => {
    document.title = title;
  }, [title]);
};
